import { render, staticRenderFns } from "./TicketComments.vue?vue&type=template&id=75ebbbfa"
import script from "./TicketComments.vue?vue&type=script&lang=js"
export * from "./TicketComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports